import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AboutSubNav from '../../components/AboutSubNav';
import ClientsMarquee from '../../components/ClientsMarquee';
import GlobalPresenceMap from '../../components/GlobalPresenceMap';
import { EXPORT_COUNTRIES } from '../../mock/mock';

const EXPORT_ONLY = EXPORT_COUNTRIES.filter(c => !c.home);

const Clients = () => {
  return (
    <div>
      <section className="pt-24 pb-16 bg-[#f2ebde]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs tracking-[0.32em] uppercase text-[#a67c3d] mb-5">About &middot; Clients</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#1a1614] leading-[1.05] max-w-4xl">
            Made for <span className="italic text-[#a67c3d]">exacting briefs</span>.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-[#4a3f36] leading-relaxed">
            RCD manufactures furniture and engineered wood flooring for hotel groups, architects, interior designers, procurement teams, retailers, institutions and international buyers. Each engagement is developed around the approved brief, with close attention to materials, construction, finish, consistency and dispatch requirements.
          </p>
        </div>
      </section>

      <AboutSubNav />

      {/* Hospitality Leaders — running marquee only (grid removed) */}
      <ClientsMarquee background="#faf6f0" speed={60} showName={false} />

      {/* GLOBAL PRESENCE — right-to-left export country flags */}
      <section className="py-20 md:py-24 bg-[#f2ebde] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-10 md:mb-12">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
            <div>
              <p className="text-[10px] md:text-xs tracking-[0.32em] uppercase text-[#a67c3d] mb-2">
                Global Presence
              </p>
              <h2 className="font-serif text-3xl md:text-5xl text-[#1a1614] leading-tight">
                Made in Jaipur, <span className="italic text-[#a67c3d]">delivered across {EXPORT_ONLY.length} countries.</span>
              </h2>
            </div>
            <p className="text-sm text-[#6b5847] max-w-md md:text-right">
              Contract-grade furniture shipped from our Jaitpura atelier to hospitality &amp; retail clients around the world.
            </p>
          </div>
        </div>

        {/* World map with flag pins on every country we deliver to */}
        <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-14 md:mb-16">
          <GlobalPresenceMap />
        </div>

        <div
          className="relative w-full"
          data-testid="global-presence-marquee"
          style={{
            maskImage:       'linear-gradient(to right, transparent 0, #000 6%, #000 94%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to right, transparent 0, #000 6%, #000 94%, transparent 100%)'
          }}
        >
          <div className="flex gap-8 md:gap-12 rcd-slide-rtl" style={{ width: 'max-content' }}>
            {[...EXPORT_ONLY, ...EXPORT_ONLY].map((c, i) => (
              <div
                key={i}
                data-testid={`flag-${c.short.toLowerCase().replace(/\s+/g, '-')}-${i}`}
                className="group flex-shrink-0 flex flex-col items-center justify-center"
              >
                <div className="relative w-40 md:w-56 h-28 md:h-36 overflow-hidden bg-[#faf6f0] border border-[#e0d6c5] shadow-md group-hover:shadow-xl group-hover:-translate-y-1 transition-all duration-500">
                  <img
                    src={c.flag}
                    alt={`${c.name} flag`}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a1614]/25 via-transparent to-transparent pointer-events-none" />
                </div>
                <p className="mt-4 font-serif text-lg md:text-xl text-[#1a1614] tracking-tight text-center">
                  {c.short}
                </p>
                <p className="text-[10px] md:text-[11px] tracking-[0.28em] uppercase text-[#a67c3d]">
                  {c.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        <p className="text-center mt-10 text-xs tracking-[0.24em] uppercase text-[#8a7f6f]">
          North America &middot; Europe &middot; Africa
        </p>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-wrap justify-between items-center gap-6">
          <Link to="/about/founder" className="rcd-link text-sm text-[#1a1614]">&larr; The Directors</Link>
          <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 bg-[#1a1614] text-[#faf6f0] hover:bg-[#a67c3d] transition-colors text-sm">
            Become a Client <ArrowRight size={15} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Clients;
